/**
 * <QuestCardSkeleton> — la forme d'une carte de quête pendant le chargement.
 *
 * La vraie carte, la place de celui qui porte la quête, l'intitulé, la phrase, la barre et une
 * chip : la géométrie est celle de `<QuestCard>`, importée et non recopiée.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { STEP_BAR_HEIGHT } from "../../atoms/SegmentedBar"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"
import { QUEST_CHAMPION_HERO_SIZE, QUEST_CHAMPION_SIZE } from "./QuestCard"

export type QuestCardSkeletonProps = {
    /** La carte porte-t-elle celui qui mène la quête ? Défaut `true`. */
    champion?: boolean
    /** En tête d'un écran : sa tête à sa plus grande taille. Défaut `false`. */
    hero?: boolean
}

export function QuestCardSkeleton(props: QuestCardSkeletonProps) {
    const { champion = true, hero = false } = props

    return (
        <Card p="4">
            <Stack gap="3">
                <Row gap="3" align="start">
                    {champion && (
                        <Skeleton shape="circle" size={hero ? QUEST_CHAMPION_HERO_SIZE : QUEST_CHAMPION_SIZE} />
                    )}
                    <Stack gap="1" style={styles.body}>
                        <Skeleton textSize="text-xs" width={120} />
                        <Skeleton textSize="text-lg" width="90%" />
                    </Stack>
                </Row>
                <View>
                    <Skeleton shape="block" height={STEP_BAR_HEIGHT} radius="full" />
                </View>
                <Skeleton shape="chip" width={96} />
            </Stack>
        </Card>
    )
}

const styles = StyleSheet.create(() => ({
    body: { flex: 1, flexShrink: 1, minWidth: 0 },
}))
